export enum LIST_TYPE {
  LIST1 = "L1",
  LIST2 = "L2",
  LIST3 = "L3",
  LIST4 = "L4",
}
